import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {TweenLite} from 'gsap';

declare const fbq: any;

@Component({
  selector: 'app-home2',
  styleUrls: ['./home2.component.scss'],
  templateUrl: './home2.component.html'
})
export class Home2Component implements OnInit {
  emailContent = 'mailto:backpackers@fooncash.com?Subject=From%20Fooncash%20Website';
  isFirstTime = false;
  constructor(private title: Title) { this.title.setTitle('Fooncash - Home'); }

  ngOnInit(): void {
    this.initAnimation();
    fbq('track', 'ViewContent');
  }

  private toggleButtonColor(): void {
    TweenLite.set('#left-side > a', {className: this.isFirstTime ? '-' : '+' + '=active'});
    this.isFirstTime = !this.isFirstTime;
  }

  private initAnimation(): void {
    TweenLite.from('#right-side', 0.5, { left: 500, delay: 0.3});
    TweenLite.from('#left-side', 0.5, { right: 500});
    TweenLite.from('#home-iphone-x-img', 0.5, { opacity: 0, delay: 0.5});
    TweenLite.from('.home-article', 0.5, { opacity: 0, delay: 0.5});
    TweenLite.from('#left-side > a', 0.3, { delay: 0.9, onStart: this.toggleButtonColor, onComplete: this.toggleButtonColor});
    TweenLite.from('#left-side > a', 0.5, { opacity: 0, delay: 0.8});
  }
}
